import { apiNWL, apiController, restartApiCotroller } from '@/utils/nwlApi';
import store from '@/redux/store';
import { setShowLoader } from '@/redux/slices/loaderSlice';

const getLocations = async (orgId) => {
    try {
        restartApiCotroller();
        store.dispatch(setShowLoader(false));
        const response = await apiNWL.get(
            `/organisations/${orgId}/locations`,
            {
                signal: apiController.signal,
            },
        );
        return response.data || {};
    } catch (error) {
        console.error(error);
    }
};

const getLocationCoords = async (orgId, locId) => {
    try {
        restartApiCotroller();
        store.dispatch(setShowLoader(false));
        const response = await apiNWL.get(
            `/organisations/${orgId}/locations/${locId}`,
            {
                signal: apiController.signal,
            },
        );
        return response.data || {};
    } catch (error) {
        console.error(error);
    }
};

export { getLocationCoords, getLocations };
